import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

export const useIsEmailHubNewsletterPhaseCEnabled = (): boolean => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(
    currentCommunitySettings?.email_hub_newsletter_phase_c_enabled,
  );
};
